// 海报M页路由
export default {
  routes: [
    {
      path: '/(\\s*)posterPage(\\d*)/(\\s*)index(\\d*)',
      name: 'posterPageIndex',
      meta: {
        desc: '海报页'
      },
      component: () =>
        import(/* webpackChunkName: "posterPageIndex" */ '../views/posterPage/index.vue')
    }
  ]
}
